import React, { useCallback, useEffect } from "react";
import {
    ReactFlow,
    MiniMap,
    Controls,
    Background,
    useNodesState,
    useEdgesState,
    addEdge,
} from '@xyflow/react';
import dagre from "dagre";

import '@xyflow/react/dist/style.css';
import './index.scss';

import ContactInfo from "../../../components/ContactInfo";
import { useDispatch } from "react-redux";
import { getData } from "../../../actions/apiCall";
// const initialNodes: any = [
//     {
//         id: '1',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '2',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '3',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '4',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '5',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '6',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
//     {
//         id: '7',
//         position: { x: 300, y: 50 },
//         data: {
//             label: <ContactInfo
//                 avatarUrl='https://i.pravatar.cc/300'
//                 email="skanfade@gmail.com"
//                 name="Shubham Kanfade"
//                 phone="+91 898989898"
//                 role="BDE"
//             />
//         }
//     },
// ];

// const initialEdges = [
//     { id: 'e1-2', source: '1', target: '2' },
//     { id: 'e1-3', source: '1', target: '3' },
//     { id: 'e3-4', source: '3', target: '4' },
//     { id: 'e2-5', source: '2', target: '5' },
//     { id: 'e4-6', source: '4', target: '6' },
//     { id: 'e1-7', source: '1', target: '7' }

// ];

const nodeWidth = 300;
const nodeHeight = 150;


const OrganizationTree = () => {
    const [nodes, setNodes, onNodesChange] = useNodesState([]);
    const [edges, setEdges, onEdgesChange] = useEdgesState([]);
    const dispatch = useDispatch()

    const getLayoutedElements = (nodes, edges, direction = 'TB', yOffset = 0) => {
        const dagreGraph = new dagre.graphlib.Graph();
        dagreGraph.setDefaultEdgeLabel(() => ({}));

        dagreGraph.setGraph({ rankdir: direction });

        nodes.forEach((node) => {
            dagreGraph.setNode(node.id, { width: nodeWidth, height: nodeHeight });
        });

        edges.forEach((edge) => {
            dagreGraph.setEdge(edge.source, edge.target);
        });

        dagre.layout(dagreGraph);

        const layoutedNodes = nodes.map((node) => {
            const nodeWithPosition = dagreGraph.node(node.id);
            return {
                ...node,
                position: {
                    x: nodeWithPosition.x - nodeWidth / 2,
                    y: nodeWithPosition.y - nodeHeight / 2 + yOffset,
                },
                draggable: false,
            };
        });

        return { nodes: layoutedNodes, edges };
    };

    const convertToFlowData: any = (rootUser, hierarchyList) => {
        const allUsers = [rootUser, ...hierarchyList];

        const nodes = allUsers.map((user) => ({
            id: user._id.toString(),
            position: { x: 0, y: 0 }, // actual position will be handled by dagre
            data: {
                label: (
                    <ContactInfo
                        avatarUrl={user.avatar ? process.env.FILE_URL + user.avatar : ''}
                        email={user.workEmail || user.email}
                        name={`${user.firstName} ${user.lastName}`}
                        phone={user.mobile || ''}
                        role={user.jobTitle || ''}
                    />
                ),
            },
        }));

        const edges = hierarchyList
            .filter((user) => user.reportingManager)
            .map((user) => ({
                id: `e${user.reportingManager}-${user._id}`,
                source: user.reportingManager.toString(),
                target: user._id.toString(),
            }));

        return { nodes, edges };
    };

    useEffect(() => {
        getUsers()
    }, [])

    const getUsers = async () => {
        try {
            const resData = await dispatch(getData('/users/get/employee/directory'));

            if (resData.data) {
                const { nodes, edges } = convertToFlowData(resData.data, resData.data.reportingHierarchy)
                const { nodes: layoutedNodes, edges: layoutedEdges } = getLayoutedElements(nodes, edges);

                setNodes(layoutedNodes);
                setEdges(layoutedEdges);
            }

        } catch (error) {

        }
    }

    const onConnect = useCallback((params) => setEdges((eds) => addEdge(params, eds)), [setEdges]);

    return (
        <div style={{ height: '75vh' }}>
            <ReactFlow
                nodes={nodes}
                edges={edges}
                onNodesChange={onNodesChange}
                onEdgesChange={onEdgesChange}
                onConnect={onConnect}
                maxZoom={0.8}
                fitView
            >
                <MiniMap />
                <Controls />
                <Background />
            </ReactFlow>
        </div>
    );
}

export default OrganizationTree;
